/**
 * Os dados do painel da conversa lidos do store — UMA leitura para o cartão
 * flutuante do trilho (§5.1). Tudo passa pelos
 * utils puros (`progresso-do-turno.js`, `contexto-do-painel.js`,
 * `linhas-do-indice.js`); aqui só se junta o que o store tem.
 *
 * Leitura direta (`$store.getters[ns + '/x']`), sem `mapGetters`: namespace
 * sem o getter devolve `undefined` e cai no default, e os testes montam com
 * store real ou plano (mesmo motivo do `artefato-preview-card.vue`).
 */
import { getPersona } from '@modules/aawz-intelligence-v2/constants/Personas'
import { linhasDoIndice } from '@modules/aawz-intelligence-v2/components/chat-indice-artefatos/linhas-do-indice'
import { contextoDoPainel, nomeDoClienteEmFoco } from '@modules/aawz-intelligence-v2/utils/contexto-do-painel'
import {
  progressoDoTurno,
  resumoDoProgresso,
  ultimaRespostaDoAssistente,
} from '@modules/aawz-intelligence-v2/utils/progresso-do-turno'
import { STORE_DO_PAINEL } from './painel-do-chat.constantes'

export default {
  props: {
    storeModule: {
      type: String,
      default: STORE_DO_PAINEL,
    },
  },
  computed: {
    turnoEmVoo() {
      return Boolean(this.lerDoPainel('chatLoading'))
    },
    mensagensDoPainel() {
      return this.lerDoPainel('messages') || []
    },
    // Só com PLANO explícito (getter `plano` / `message.plano`, spec-008); turno comum → [].
    progressoDoPainel() {
      return progressoDoTurno({
        emVoo: this.turnoEmVoo,
        planoAoVivo: this.lerDoPainel('plano') || null,
        mensagens: this.mensagensDoPainel,
      })
    },
    resumoDoPainel() {
      return resumoDoProgresso(this.progressoDoPainel)
    },
    entregasDoPainel() {
      return linhasDoIndice(
        this.lerDoPainel('artefatosDaConversa') || [],
        this.lerDoPainel('artefatoIdentidadeAtiva') || null
      )
    },
    // Ao vivo, o fan-out do turno; fora dele, os agentes da última resposta
    // (mapa do `end`) ou, reaberta, o `agent_slug` dela.
    agentesDoPainel() {
      if (this.turnoEmVoo) return this.lerDoPainel('agentesDoTurnoAoVivo') || []
      const resposta = ultimaRespostaDoAssistente(this.mensagensDoPainel)
      const buscar = this.lerDoPainel('agentesDaMensagem')
      const doMapa = resposta && resposta.id && buscar ? buscar(resposta.id) : []
      if (doMapa && doMapa.length) return doMapa
      const atual = this.lerDoPainel('agenteAtualDaConversa')
      return atual ? [atual] : []
    },
    clienteDoPainel() {
      const conversa = this.lerDoPainel('selectedConversation')
      return nomeDoClienteEmFoco({
        clienteDaConversa: this.lerDoPainel('clienteDaConversaAtual'),
        idDaConversa: conversa && conversa.id ? conversa.id : null,
        clienteEscopo: this.lerDoPainel('clienteEscopo'),
      })
    },
    contextoDoPainel() {
      return contextoDoPainel({
        cliente: this.clienteDoPainel,
        agentes: this.agentesDoPainel,
        mensagens: this.mensagensDoPainel,
        mostraFontes: getPersona(this.lerDoPainel('persona')).mostraFontes,
      })
    },
  },
  methods: {
    lerDoPainel(getter) {
      const store = this.$store
      if (!store || !store.getters) return undefined
      return store.getters[this.storeModule + '/' + getter]
    },
    despacharNoPainel(action, payload) {
      if (!this.$store) return
      this.$store.dispatch(this.storeModule + '/' + action, payload)
    },
  },
}
